// HistoryList.js
import React, {Fragment} from 'react';
import HistoryItem from './HistoryItem';
import HistoryItemPlaceholder from "./HistoryItemPlaceholder";

export default function HistoryList({ history, onLoadMore, onAddMoodboard, onGenerate, onDelete, initiated, onEditItem, hideLoadMore, onRegenerate }) {
  return (
    <div className="ai-requests-history">
      <div className="history-list">
        {history.map(item => (
          <HistoryItem
            key={item.id || item.external_id}
            item={item}
            onGenerate={onGenerate}
            onEditItem={onEditItem}
            onDelete={onDelete}
            onAddMoodboard={onAddMoodboard}
            onRegenerate={onRegenerate}
          />
        ))}
        {!initiated && (
          <Fragment>
            <HistoryItemPlaceholder key="p1" />
            <HistoryItemPlaceholder key="p2" />
            <HistoryItemPlaceholder key="p3" />
            <HistoryItemPlaceholder key="p4" />
          </Fragment>
        )}
        {!hideLoadMore && initiated && (
          <div className="history-list-actions">
            <button onClick={onLoadMore} className="btn -empty -y2023 load-more">Load More</button>
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/moodboard_ai_requests/HistoryList.js